import _ListItemText from "@mui/material/ListItemText";
import _CardActions from "@mui/material/CardActions";
import _Card from "@mui/material/Card";
import _Collapse from "@mui/material/Collapse";
import _List from "@mui/material/List";
import _Divider from "@mui/material/Divider";
import _ListItem from "@mui/material/ListItem";
import _ListItemButton from "@mui/material/ListItemButton";
import _Typography from "@mui/material/Typography";
import _ListItemIcon from "@mui/material/ListItemIcon";
import _Tooltip from "@mui/material/Tooltip";
import _ExpandMore from "@mui/icons-material/ExpandMore";
import _ExpandLess from "@mui/icons-material/ExpandLess";
import _CardHeader from "@mui/material/CardHeader";
import _Train from "@mui/icons-material/Train";
import _DirectionsWalk from "@mui/icons-material/DirectionsWalk";
import _DirectionsBike from "@mui/icons-material/DirectionsBike";
import React, { Fragment } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { useUnits } from '../../hooks';
import { instructionDirectionsMap, instructionFacilitiesMap, instructionOrientationsMap } from '../../models';
import { Button } from '../button';
function SectionCard({
  route: {
    sections
  },
  sectionIndex,
  detailsShowed,
  handleDetailsShowed,
  handleHighlight
}) {
  const {
    t
  } = useTranslation();
  const {
    toTime,
    toDistance
  } = useUnits();
  const section = sections[sectionIndex];
  const {
    transportMode,
    direction,
    duration,
    distance
  } = section;
  const instructions = 'instructions' in section && section.instructions.filter(({
    direction
  }) => direction !== 'reachedYourDestination' && direction !== 'takeSharedBike') || undefined;
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(_Card, null, /*#__PURE__*/React.createElement(_CardHeader, {
    avatar: transportMode === 'bike' ? /*#__PURE__*/React.createElement(_DirectionsBike, {
      color: "primary"
    }) : transportMode === 'pedestrian' ? /*#__PURE__*/React.createElement(_DirectionsWalk, {
      color: "primary"
    }) : /*#__PURE__*/React.createElement(_Train, {
      color: "primary"
    }),
    subheader: /*#__PURE__*/React.createElement(React.Fragment, null, toTime(duration), " \u2022 ", toDistance(distance)),
    title: /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "commons.routing.roadmap.via_direction",
      values: {
        direction
      }
    })
  }), (transportMode === 'bike' || transportMode === 'pedestrian') && instructions && instructions.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledActions, null, detailsShowed ? /*#__PURE__*/React.createElement(Button, {
    endIcon: /*#__PURE__*/React.createElement(_ExpandLess, null),
    onClick: () => handleDetailsShowed(false)
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.actions.hide_details"
  })) : /*#__PURE__*/React.createElement(Button, {
    endIcon: /*#__PURE__*/React.createElement(_ExpandMore, null),
    onClick: () => handleDetailsShowed(true)
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.actions.see_details"
  }))), instructions && instructions.length > 0 && /*#__PURE__*/React.createElement(_Collapse, {
    in: detailsShowed
  }, /*#__PURE__*/React.createElement(_List, null, instructions.map(({
    orientation: orientationKey,
    direction: directionKey,
    roadName,
    facility: facilityKey,
    distance,
    geometryIndex
  }, index) => {
    const direction = instructionDirectionsMap[directionKey];
    const {
      labelKey
    } = instructionOrientationsMap[orientationKey];
    const DirectionIcon = direction?.Icon;
    const facility = instructionFacilitiesMap[facilityKey];
    const FacilityIcon = facility?.Icon;
    return /*#__PURE__*/React.createElement(Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement(_ListItem, {
      disablePadding: true,
      secondaryAction: facility && FacilityIcon && /*#__PURE__*/React.createElement(_Tooltip, {
        placement: "left",
        title: /*#__PURE__*/React.createElement(Trans, {
          i18nKey: facility.labelKey
        })
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FacilityIcon, {
        color: "action"
      }))),
      sx: {
        zIndex: 2
      }
    }, /*#__PURE__*/React.createElement(_ListItemButton, {
      onClick: () => handleHighlight?.({
        sectionIndex,
        geometryIndex
      }, true),
      onMouseEnter: () => handleHighlight?.({
        sectionIndex,
        geometryIndex
      }),
      onMouseLeave: () => handleHighlight?.(null),
      sx: {
        minHeight: 64
      }
    }, /*#__PURE__*/React.createElement(_ListItemIcon, null, DirectionIcon && /*#__PURE__*/React.createElement(DirectionIcon, {
      color: "primary"
    })), /*#__PURE__*/React.createElement(StyledListItemText, {
      secondary: direction && /*#__PURE__*/React.createElement(_Typography, {
        variant: "caption"
      }, /*#__PURE__*/React.createElement(Trans, {
        i18nKey: direction.labelKey,
        values: {
          context: roadName || facility ? 'detailed' : '',
          orientation: t(labelKey),
          roadName: roadName || (facility ? t(facility.labelKey).toLowerCase() : '')
        }
      }))
    }))), index < instructions.length - 1 && /*#__PURE__*/React.createElement(DividerWrapper, null, /*#__PURE__*/React.createElement(_Divider, null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Typography, {
      color: "textSecondary",
      variant: "caption"
    }, toDistance(distance || 0)))));
  }))))));
}
const Wrapper = styled.div`
  margin: 0 0 0 48px;
`;
const StyledActions = styled(_CardActions)`
  justify-content: flex-end;
`;
const StyledListItemText = styled(_ListItemText)`
  padding-right: 32px;
`;
const DividerWrapper = styled.div`
  position: relative;

  > div {
    background-color: white;
    left: 0;
    padding: 0 4px 0 16px;
    position: absolute;
    top: -10px;
  }
`;
export default SectionCard;